import { render, staticRenderFns } from "./SharedWeddingList.vue?vue&type=template&id=77602864&scoped=true"
import script from "./SharedWeddingList.vue?vue&type=script&lang=js"
export * from "./SharedWeddingList.vue?vue&type=script&lang=js"
import style0 from "./SharedWeddingList.vue?vue&type=style&index=0&id=77602864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77602864",
  null
  
)

export default component.exports